<template>
<div>
    <el-row>
        <el-col>
            <el-button type="success" size="small" @click.stop="newInventoryClick" @click="inventoryBool=true" style="float: left;background-color: #4ec880;color: white;border: 1px solid #4ec880;margin-bottom: 4px;">
                <i :class="['iconfont', 'el-icon-plus']" style="color: #ffffff"></i>
                添加
            </el-button>
        </el-col>

    </el-row>
    <el-row style="display: flex;flex-wrap: wrap;margin-top: 10px">
        <ul style="width: 100%;height: 100%">
            <li style="width: 420px;border: 1px solid #ededed;height: 90px;padding: 10px 20px 10px 10px;
            float: left;margin-right: 20px">
                <div style="width: 70px;height: 70px;margin-top: 10px;float: left;margin-left: 10px;">
                    <img src="../../../../assets/images/tou.png" alt=""
                         style="width: 100%;height: 100%;object-fit: cover">
                </div>
                <div style="width: 325px;float: left;height: 100%;margin-left: 15px">
                    <p style="margin: 10px 0;line-height: 100%">
                        <span style="color: #fff;background-color: #ff9901;
                        border: 1px solid #ff9901;margin-top: -2px;
                        border-radius:4px;font-size: 12px;padding: 0 6px">重点推荐</span>
                        <span style="color: #4D586D;font-size: 16px;">2019年心血管新品介绍</span>
                        <span style="color: #ED3B3F;float: right;font-size: 12px;cursor:pointer;">
                                移除
                        </span>
                    </p>
                    <p style="margin: 10px 0">
                        <span style="color: #B0B5B9;font-size: 13px;">类型：文档</span>
                        <span style="color: #B0B5B9;font-size: 13px;margin-left: 20px">大小：3.6MB</span>
                    </p>
                    <p style="margin: 10px 0">
                         <span style="color:#4A90E2;font-size: 13px">
                                   日期: 2019年9月12日 11:32
                                </span>
                        <span style="color: #4A90E2;font-size: 13px;margin-left: 20px">
                                  播放时长：3分钟
                                </span>
                    </p>
                </div>
            </li>
            <li style="width: 420px;border: 1px solid #ededed;height: 90px;padding: 10px 20px 10px 10px;
            float: left;margin-right: 20px">
                <div style="width: 70px;height: 70px;margin-top: 10px;float: left;margin-left: 10px;">
                    <img src="../../../../assets/images/tou.png" alt=""
                         style="width: 100%;height: 100%;object-fit: cover">
                </div>
                <div style="width: 325px;float: left;height: 100%;margin-left: 15px">
                    <p style="margin: 10px 0;line-height: 100%">
                        <span style="color: #4D586D;font-size: 16px;">心血管疾病治疗场景(3D)</span>
                        <span style="color: #ED3B3F;float: right;font-size: 12px;cursor:pointer;">
                                移除
                        </span>
                    </p>
                    <p style="margin: 10px 0">
                        <span style="color: #B0B5B9;font-size: 13px;">类型：文档</span>
                        <span style="color: #B0B5B9;font-size: 13px;margin-left: 20px">大小：3.6MB</span>
                    </p>
                    <p style="margin: 10px 0">
                         <span style="color:#4A90E2;font-size: 13px">
                                   日期: 2019年9月12日 11:32
                                </span>
                        <span style="color: #4A90E2;font-size: 13px;margin-left: 20px">
                                  播放时长：3分钟
                                </span>
                    </p>
                </div>
            </li>
        </ul>
    </el-row>
    <!--        库存采集-->
    <el-dialog
            :visible.sync="inventoryBool"
            width="500px"
            :show-close="false"
            style="vertical-align: center;: #FFF9F3">
        <div>
            <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 20px;">
                <el-col :span="12">
                    <div style="color: #3998F7;font-size: 26px">推广资料播放记录
                    </div>
                </el-col>
                <el-col :span="12">
                    <div align="right">
                        <el-button type="primary" size="small" @click.stop="editInventoryInfo" @click="inventoryBool = false">
                            保存
                        </el-button>
                        <el-button type="danger" size="small" @click="inventoryBool = false">
                            关闭
                        </el-button>
                    </div>
                </el-col>
            </el-row>
            <div id="inventory" style="margin-top: 20px;">
                <el-row style="display: flex;flex-wrap: wrap;">
                    <ul style="width: 100%;height: 100%">
                        <li style="width: 420px;border: 1px solid #ededed;height: 90px;padding: 10px 20px 10px 10px;">
                            <div style="width: 70px;height: 70px;margin-top: 10px;float: left;margin-left: 10px;">
                                <img src="../../../../assets/images/tou.png" alt=""
                                     style="width: 100%;height: 100%;object-fit: cover">
                            </div>
                            <div style="width: 305px;float: left;height: 100%;margin-left: 15px">
                                <p style="margin: 10px 0;line-height: 100%">
                        <span style="color: #fff;background-color: #ff9901;
                        border: 1px solid #ff9901;margin-top: -2px;
                        border-radius:4px;font-size: 12px;padding: 0 6px">重点推荐</span>
                                    <span style="color: #4D586D;font-size: 16px;">2019年心血管新品介绍</span>
                                    <span style="color: #ED3B3F;float: right;font-size: 12px;cursor:pointer;">
<!--                                移除-->
                        </span>
                                </p>
                                <p style="margin: 15px 0">
                                    <span style="color: #B0B5B9;font-size: 13px;">类型：文档</span>
                                    <span style="color: #B0B5B9;font-size: 13px;margin-left: 20px">大小：3.6MB</span>
                                </p>
                                <p style="margin: 10px 0">
                         <span style="color:#4A90E2;font-size: 13px">
                                   日期: 2019年9月12日 11:32
                                </span>
                                    <span style="color: #4A90E2;font-size: 13px;margin-left: 20px">
                                  播放时长：3分钟
                                </span>
                                </p>
                            </div>
                            <div style="width: 20px;height: 100%;float: left;line-height: 100%">
                                <img  :src="check"  @click.stop="medialImgClick(j)" alt="" style="
                                width: 20px;height: 20px;margin-top: 35px">
                            </div>
                        </li>
                        <li style="width: 420px;border: 1px solid #ededed;height: 90px;padding: 10px 20px 10px 10px; ">
                            <div style="width: 70px;height: 70px;margin-top: 10px;float: left;margin-left: 10px;">
                                <img src="../../../../assets/images/tou.png" alt=""
                                     style="width: 100%;height: 100%;object-fit: cover">
                            </div>
                            <div style="width: 305px;float: left;height: 100%;margin-left: 15px">
                                <p style="margin: 10px 0;line-height: 100%">
                                    <span style="color: #4D586D;font-size: 16px;">心血管疾病治疗场景(3D)</span>
                                    <span style="color: #ED3B3F;float: right;font-size: 12px;cursor:pointer;">
<!--                                移除-->
                        </span>
                                </p>
                                <p style="margin: 15px 0">
                                    <span style="color: #B0B5B9;font-size: 13px;">类型：文档</span>
                                    <span style="color: #B0B5B9;font-size: 13px;margin-left: 20px">大小：3.6MB</span>
                                </p>
                                <p style="margin: 10px 0">
                         <span style="color:#4A90E2;font-size: 13px">
                                   日期: 2019年9月12日 11:32
                                </span>
                                    <span style="color: #4A90E2;font-size: 13px;margin-left: 20px">
                                  播放时长：3分钟
                                </span>
                                </p>
                            </div>
                            <div style="width: 20px;height: 100%;float: left;line-height: 100%">
                                <img  :src="check"  @click.stop="medialImgClick(j)" alt="" style="
                                width: 20px;height: 20px;margin-top: 35px">
                            </div>
                        </li>
                    </ul>
                </el-row>
            </div>
        </div>

    </el-dialog>
</div>
</template>

<script>
    import check from '../../../../assets/images/check.png'
    export default {
        name: "assistantEducation",
        data(){
            return{
                addInventory:{},
                inventoryBool:false,
                check : check,

            }
        },
        created() {
        },
        mounted() {
        },
        methods: {
            newInventoryClick(){
                this.addInventory = {}
            },
            }
    }
</script>

<style scoped>
    #inventory >>>.el-form-item__label{
        font-size: 14px;
        color: #000000;
        text-align: right;
        font-weight: bold;
    }
</style>



// WEBPACK FOOTER //
// src/pages/calendar/components/components/assistantEducation.vue